module.exports = __webpack_public_path__ + "static/media/stripe-express-onboarding_5.e6ab1807.png";